import classNames from "classnames/bind";
import React from "react";
import { Card } from "../../Card";
import { Skeleton } from "../../Skeleton";
import styles from "./ImageCard.module.scss";
import type ImageCardProps from "./types";

const cx = classNames.bind(styles);

const ImageCard = ({
  id,
  title,
  onClick,
  isLoading = false,
  meta,
  image,
  imageAlt = "",
  placeholder,
}: ImageCardProps) => (
  <Card
    className={cx("card")}
    onClick={isLoading ? undefined : () => onClick(id)}
  >
    <Skeleton isLoading={isLoading}>
      <div className={cx("image-wrapper")}>
        <div
          className={cx("image")}
          style={image ? { backgroundImage: `url("${image}")` } : undefined}
          role={image ? "img" : undefined}
          aria-label={image ? imageAlt : undefined}
        >
          {!image ? placeholder : null}
        </div>
      </div>
    </Skeleton>

    <div className={cx("titleContainer")}>
      <Skeleton isLoading={isLoading}>
        <p className={cx("title")}>{title}</p>
      </Skeleton>
    </div>

    <Skeleton isLoading={isLoading}>
      <p className={cx("meta")}>{meta}</p>
    </Skeleton>
  </Card>
);

export default ImageCard;
